<template>
  <div class="page">    
    <div class="page__header-box">
      <div class="page__header">
        <div class="page__header__content">
          <div class="page__header__content__left" @click="goHome">
            <img class="page__header__content__logo" src="https://file.liuyamed.com/Fhe6_sebxKyGrFGHYCbCbPsrzDnS" />
            <img class="page__header__content__img" src="https://file.liuyamed.com/Fv50kKi0SLEcIdm4AccJX3ROjgoX" />
          </div>
          <div class="page__header__content__right" @click="goContact">联系我们</div>
        </div>
      </div>
    </div>
    <div class="page__body">
      <div class="page__body__left">
        <div class="page__body__left__wrap" v-if="journalList.length > 0" style="padding: 15rem 19rem; display: flex; flex-direction: row; align-items: center;">
          <img class="journal__single__img" :src="journalList[0].cover || ''" @click="handleJournalDetail(journalList[0].id)" />
          <div class="journal__single__textWrap">
            <div class="journal__single__textWrap__title" @click="handleJournalDetail(journalList[0].id)">{{journalList[0].title || ''}}</div>
            <div class="journal__single__textWrap__content">
              <div class="journal__single__textWrap__content__text">主管单位：</div>
              <div class="journal__single__textWrap__content__text" style="flex: 1;">{{journalList[0].organizer || ''}}</div>
            </div>
            <div class="journal__single__textWrap__content">
              <div class="journal__single__textWrap__content__text">主办单位：</div>
              <div class="journal__single__textWrap__content__text" style="flex: 1;">{{journalList[0].host_company || ''}}</div>
            </div>
            <div class="journal__single__textWrap__content">
              <div class="journal__single__textWrap__content__text">国际刊号：</div>
              <div class="journal__single__textWrap__content__text" style="flex: 1;">{{journalList[0].international_issue || ''}}</div>
            </div>
            <div class="journal__single__textWrap__content">
              <div class="journal__single__textWrap__content__text">国际内号：</div>
              <div class="journal__single__textWrap__content__text" style="flex: 1;">{{journalList[0].international_internal_number || ''}}</div>
            </div>
          </div>
        </div>
        <div class="page__body__left__wrap">
          <div class="journal__header">
            <div class="journal__header__title">期刊列表</div>
            <div class="journal__header__right" @click="handleJournalList()">
              查看全部
              <img class="journal__header__right__img" src="https://file.liuyamed.com/FjoYOwZcjUbyNQExTsUQbrpnOGTV" />
            </div>
          </div>
          <div class="journal__list">
            <div v-for="(item, index) in journalList" :key="item.id" class="journal__list__itemWrap" :style="index + 1 == journalList.length ? 'width: 15%;' : ''" @click="handleJournalDetail(item.id)">
              <div class="journal__list__item">
                <img class="journal__list__item__img" :src="(item.cover || '')" />
                <div class="journal__list__item__name">{{item.year}}年{{item.num}}期</div>
              </div>
            </div>
          </div>
        </div>
        <div class="page__body__left__wrap">
          <div class="title">通知与文章</div>
          <div v-for="(item, index) in list" :key="item.id" :style="index + 1 == list.length ? 'border-bottom: 0; padding-bottom: 0;' : ''" class="item" @click="handleDetail(item.id)">
            <div class="item__left">{{item.type == '2' ? '通 知' : '文 章'}}</div>
            <div class="item__right">
              <div class="item__right__title">{{item.title || ''}}</div>
              <div class="item__right__subtitle">{{item.author || ''}}</div>
              <div class="item__right__subtitle">{{getTime(item.time || '')}}</div>
            </div>
          </div>
        </div>
        <div style="margin-left: -8rem;">
          <el-pagination
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <PageRight />
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import LY from '../utils/liuya-js-sdk'
import PageRight from '../components/PageRight/index.vue'
import { get } from '../utils/request'

export default {
  name: 'Home',
  components: {
    PageRight
  },
  data () {
    return {
      list: [],
      total: 0,
      journalList: []
    }
  },
  mounted() {
    const that = this
    get('https://api.science.baichuanbailian.com/api/1.0/journal/index', { page: 1 }).then(res => {      
      if (res.code == 200) {
        let arr = res.data.data || []
        that.journalList = arr.slice(0, 4)
        console.log(res.data.data || [])
      }
    })
    get('https://api.science.baichuanbailian.com/api/1.0/post-notice/index', { page: 1 }).then(res => {      
      if (res.code == 200) {
        this.list = res.data.data || []
        this.total = res.data.total || 0
      }
    })
  },  
  methods: {
    goHome() {
      let routeData = this.$router.resolve({ path: '/' });
      window.open(routeData.href, '_blank');
    },
    goContact() {
      let routeData = this.$router.resolve({ path: '/contact' });
      window.open(routeData.href, '_blank');
    },
    getTime(time) {
      if (!time) return ''
      let arr = time.split(' ')[0].split('-')
      return `${arr[0]}年${arr[1]}月${arr[2]}日`
    },
    handleCurrentChange(val) {
      document.documentElement.scrollTop = 0;
      get('https://api.science.baichuanbailian.com/api/1.0/post-notice/index', { page: val }).then(res => {      
        if (res.code == 200) {
          this.list = res.data.data || []
        }
      })
    },
    handleDetail(id) {
      let routeData = this.$router.resolve({ path: '/detail/' + id });
      window.open(routeData.href, '_blank');
    },
    handleJournalDetail(id) {
      let routeData = this.$router.resolve({ path: '/journal-detail/' + id });
      window.open(routeData.href, '_blank');
    },
    handleJournalList() {
      let routeData = this.$router.resolve({ path: '/journal-list' });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../style/basepage.scss";

  .title {
    font-size: 14rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 22rem;
  }

  .journal__single {
    &__img {
      width: 175.5rem;
      height: 234rem;
      margin-right: 23.5rem;
    }

    &__img:hover {
      cursor: pointer;
    }

    &__textWrap {
      display: flex;
      flex-direction: column;

      &__title {
        font-size: 26rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 22rem;
        display: flex;
        margin-bottom: 15.5rem;
      }

      &__title:hover {
        cursor: pointer;
      }

      &__content {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        
        &__text {
          display: flex;
          font-size: 12rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #242424;
          line-height: 30rem;
        }
      }
    }
  }

  .journal {
    &__header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      &__title {
        font-size: 14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 22rem;
      }
      
      &__right {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 11rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 22rem;

        &__img {
          width: 3.5rem;
          height: 6rem;
          margin-left: 6rem;
        }
      }

      &__right:hover {
        cursor: pointer;
      }
    }

    &__list {
      margin-top: 13rem;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      &__itemWrap {
        width: 25.9%;
        display: flex;
        align-items: flex-start;
        box-sizing: border-box;
      }

      &__item {
        // width: 25%;
        // padding-left: 0;
        // margin-right: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 5.5rem;

        &__img {
          width: 142.5rem;
          height: 190rem;
          margin-bottom: 16.5rem;
        }

        &__name {
          font-size: 11rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 22rem;
        }
      }
      
      &__item:hover {
        cursor: pointer;
      }
    }
  }

  .item {
    padding: 14rem 0;
    display: flex;
    flex-direction: row;
    border-bottom: 0.5rem solid #F2F2F2;

    &__left {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 4.5rem;
      margin-right: 20rem;
      width: 41rem;
      height: 24.5rem;
      background: #2FCCC3;
      border-radius: 3rem;
      font-size: 10rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 22rem;
    }

    &__right {
      display: flex;
      flex: 1;
      flex-direction: column;

      &__title {
        font-size: 12.5rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 22rem;
        letter-spacing: 0.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display:-webkit-box; /*盒子模型微弹性伸缩模型*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素垂直排列*/
        -webkit-line-clamp: 1; /*文本显示1行*/
      }

      &__subtitle {
        display: flex;
        margin-top: 1rem;
        font-size: 9.5rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #7C7C7C;
        line-height: 22rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display:-webkit-box; /*盒子模型微弹性伸缩模型*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素垂直排列*/
        -webkit-line-clamp: 1; /*文本显示1行*/
      }
    }
  }

  .item:hover {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue